import { Toaster } from 'react-hot-toast';

import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import PropTypes from 'prop-types';

import AuthBootstrap from '@app/AuthBootstrap';
import { ErrorBoundary } from '@components/common';
import appConfig from '@config/app.config';
import { GlobalStyles, theme } from '@theme';

function AppProviders({ children }) {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <GlobalStyles />
      <ErrorBoundary>
        <AuthBootstrap>
          {children}
          <Toaster
            position="top-right"
            toastOptions={{
              duration: appConfig.toastDuration,
            }}
          />
        </AuthBootstrap>
      </ErrorBoundary>
    </ThemeProvider>
  );
}

AppProviders.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AppProviders;
